/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import FacebookLeadAdsService from 'cio/services/facebook-lead-ads';
import CustomFormsService from 'cio/services/custom-forms';
import { isGroupCondition } from 'cio/utils/conditions/serialize';
import GroupCondition from 'cio/app-models/conditions/group';
import CustomForm from 'cio/models/custom-form';
import FacebookLeadAdsForm from 'cio/models/facebook-lead-ads-form';
import FormEventAttributeCondition from 'cio/app-models/conditions/form-event-attribute';
import { FormArgs } from 'cio/components/campaigns/trigger/setup/condition-blocks/form/config';

export default class ConditionBlockForm extends Component<FormArgs> {
  @service facebookLeadAds!: FacebookLeadAdsService;
  @service customForms!: CustomFormsService;

  get highlight() {
    return this.conditionCount === 0;
  }

  get conditionCount() {
    return this.args.attributeFilters.children?.length ?? 0;
  }

  get overThreshold() {
    let cutThreshold = this.conditionCount > 3 ? 2 : 3;
    return this.conditionCount - cutThreshold;
  }

  get formNames() {
    let names: {
      title: string;
      text: string;
      extra?: number;
    }[] = [];
    let cutThreshold = this.conditionCount > 3 ? 2 : 3;
    this.args.attributeFilters.children.slice(0, cutThreshold).forEach((condition: GroupCondition, idx: number) => {
      if (isGroupCondition(condition) && condition?.children?.length > 0) {
        let formId =
          (
            condition.children.find(
              (child: FormEventAttributeCondition) => child?.event === 'form_submit',
            ) as FormEventAttributeCondition
          )?.value ?? '';
        let form: CustomForm | FacebookLeadAdsForm | undefined =
          this.facebookLeadAds.forms.find((f) => f.facebookFormId === formId) ??
          this.customForms.forms.find((f) => f.formIdLowercase === formId);
        if (form != null) {
          let eventConditions =
            (
              condition.children.find(
                (child: FormEventAttributeCondition) => child?.event !== 'form_submit',
              ) as FormEventAttributeCondition
            )?.children?.length ?? 0;
          names.push({
            title: idx > 0 ? 'OR Submits' : 'Submits',
            text: form.name,
            extra: eventConditions,
          });
        }
      }
    });
    return names;
  }
}
